<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{'User Information' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'User Details' | translate}}
        </li>
    </ol>
</div>
@if(isLoading){
<app-welcome-loader></app-welcome-loader>
}@else{
<!-- header part -->
<mat-card class="daxa-card profile-card mb-25 p-0 border-radius bg-white border-none d-block">
    <mat-card-content>
        <div class="cover-image position-relative border-top-radius">
            <img src="images/profile-big-cover.jpg" class="border-top-radius" alt="cover-image" />
        </div>
        <div class="profile-content">
            <div class="d-md-flex align-items-end justify-content-between">
                <div class="d-md-flex align-items-end">
                    <div class="image position-relative">
                        <img src="images/avatar-solar-smart.jpg" class="rounded-circle" alt="profile-image" />
                    </div>
                    <div class="title">
                        <span class="d-block fw-medium">
                            {{ userInfo.firstName }} {{ userInfo.lastName }}

                        </span>
                        <span class="d-block text-body">
                            {{ userInfo.email }}
                            @if(userInfo.disabled){
                            <span class="badge rounded-pill text-bg-danger active">{{'Deactive' | translate}}</span>
                            }@else {
                            <span class="badge rounded-pill text-bg-success active">{{'Active' | translate}}</span>
                            }
                        </span>

                    </div>
                </div>
                <div class="btn-box">
                    @if(userInfo.disabled){
                    <button mat-button class="badge text-outline-success" (click)="openConfirmDialog()">
                        {{'Activate' | translate}}
                    </button>
                    }@else {
                    <button mat-button class="badge text-outline-danger" (click)="openConfirmDialog()">
                        {{'Deactivate' | translate }}
                    </button>
                    }
                    <button mat-button>
                        <a routerLink="/users/users-list">{{'Back to List' | translate}}</a>
                    </button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<div class="row d-flex">
    <div class="col-xxxl-3 col-lg-4 userInfo">
        <mat-card class="daxa-card info-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-header>
                <mat-card-title>
                    <h5 class="mb-0">
                        {{'Profile Information' | translate}}
                    </h5>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <ul class="info-list pl-0 mb-25 mt-0 list-unstyled">
                    <li>
                        <span class="text-body">{{'User ID' | translate}}:</span>
                        {{ userInfo.id }}
                    </li>
                    <li>
                        <span class="text-body">{{'Full_name' | translate}}:</span>
                        {{ userInfo.firstName }} {{ userInfo.lastName }}
                    </li>
                    <li>
                        <span class="text-body">{{'Email' | translate}}:</span>
                        {{ userInfo.email }}
                    </li>
                    <li>
                        <span class="text-body">{{'Phone_number' | translate}}:</span>
                        {{ userInfo.phoneNumber }}
                    </li>
                    <li>
                        <span class="text-body">{{'Username' | translate}}:</span>
                        {{ userInfo.username }}
                    </li>
                    <li>
                        <span class="text-body">{{'Roles' | translate}}:</span>
                        <span>
                            @for(userGroup of userGroups; track $index){
                            <span> {{ userGroup.title }}</span><span *ngIf="!$last">, </span>
                            }
                        </span>
                    </li>
                </ul>
                <h5>
                    {{'Contact Info' | translate}}
                </h5>
                <div class="socials-link">
                    <a [href]="'tel:' + userInfo.phoneNumber"
                        class="mail d-inline-block text-center position-relative rounded-circle">
                        <i class="ri-phone-fill"></i>
                    </a>
                    <a [href]="'mailto:' + userInfo.email"
                        class="mail d-inline-block text-center position-relative rounded-circle">
                        <i class="ri-mail-fill"></i>
                    </a>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <!-- customer device info -->
    @if (isCustomer) {
    <div class="col-xxxl-9 col-lg-8 deviceInfo">
        <app-customer-divice-info [devices]="customerDevices" [isLoading]="customerDevicesLoading">
        </app-customer-divice-info>
    </div>
    }
</div>
}

<div class="mt-3">
    <app-plants-user [plants]="plantList || []"></app-plants-user>

    <!-- optional empty state -->
    <div *ngIf="!(plantList.length > 0)" class="none-plants text-center py-4">
        <mat-icon>
            block
        </mat-icon>
        {{'No plants available for this user.' | translate}}
    </div>
</div>